import React, { useEffect } from "react";
import App from "./App";
import { Provider } from "react-redux";
import store from "./store/configureStore";
import { SnackbarProvider } from "notistack";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import ScrollToTop from "./utils/ScrollToTop";
import SessionTimeout from "./Components/common/SessionTimeout/SessionTimeout";
import { useSelector, useDispatch } from "react-redux";
import { licenceCheckRequest } from "./store/actions/usersActions";
import Backdrop from "./Components/UI/Backdrop/Backdrop";

const theme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontSize: "0.875rem",
          backgroundColor: "var(--sidebar-background)",
        },
      },
    },
  },
  props: {
    MuiTextField: {
      variant: "outlined",
      fullWidth: true,
    },
  },
});

function RootComponent() {
  const dispatch = useDispatch();
  const licenceCheck = useSelector((state) => state.users.licenceCheck);
  const isLoading = useSelector((state) => state.users.isLoading);
  useEffect(() => {
    dispatch(licenceCheckRequest());
  }, [dispatch]);

  if (isLoading) {
    return <Backdrop absolute={true} show={isLoading} />;
  }

  if (!licenceCheck) {
    return <Backdrop absolute={true} show={!licenceCheck} />;
  }

  return (
    <BrowserRouter>
      <ScrollToTop />
      <SnackbarProvider preventDuplicate={false} maxSnack={4} autoHideDuration={2000}>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </SnackbarProvider>
      <SessionTimeout />
    </BrowserRouter>
  );
}

createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <RootComponent />
  </Provider>,
);
